import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Sling as Hamburger } from "hamburger-react";
import { device } from "../../../styles/BreakPoints";
import MobileMenu from "./MobileMenu";

const Header = () => {
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    const body = document.body;
    if (isOpen) {
      body.classList.add("blur");
    } else {
      body.classList.remove("blur");
    }
  }, [isOpen]);

  const MenuLinks = () => (
    <MenuLink>
      <a href="#about">
        <p>
          <span>01.</span>About
        </p>
      </a>
      <a href="#work">
        <p>
          <span>02.</span>Work
        </p>
      </a>
      <a href="#project">
        <p>
          <span>03.</span>Project
        </p>
      </a>
      <a href="#contact">
        <p>
          <span>04.</span>Contact
        </p>
      </a>
    </MenuLink>
  );

  return (
    <>
      <Container id="header" className="">
        <Logo>
          <a href="/">
            <LogoIcon>T</LogoIcon>
          </a>
        </Logo>
        <MenuWraper>
          <MenuLinks />
          <a href="/resume.pdf" target="_blank">
            <ResumeBtn className="resume-btn">Resume</ResumeBtn>
          </a>
        </MenuWraper>
        <MobileNav id="mobilenav">
          <div>
            <div>
              <Hamburger
                size={30}
                color="#64ffda"
                toggled={isOpen}
                toggle={setOpen}
              />
            </div>
          </div>
        </MobileNav>
      </Container>
      {/* mobile menu  */}
      <MobileMenu isOpen={isOpen} setOpen={setOpen} />
    </>
  );
};

export default Header;

// styled components
const Container = styled.header`
  color: var(--lightest-slate);
  padding-left: 50px;
  padding-right: 50px;
  font-family: ${(props) => props.theme.fonts.sf};
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: var(--nav-height);
  transition: var(--transition);
  backdrop-filter: blur(10px);

  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;

  @media ${device.lg} {
    padding-left: 40px;
    padding-right: 40px;
  }
  @media ${device.mdM} {
    padding-left: 25px;
    padding-right: 25px;
    height: var(--nav-scroll-height);
  }
`;
const Logo = styled.div`
  font-family: ${(props) => props.theme.fonts.calibre_b};
  font-size: var(--fz-xl);
  background-color: var(--green);
  border: 2px solid var(--green);
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
`;
const LogoIcon = styled.div`
  padding: 2px 7px;
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  background-color: #0a192f;
`;
const MenuWraper = styled.div`
  display: flex;
  align-items: center;

  @media ${device.mdM} {
    display: none;
  }
`;
export const MenuLink = styled.nav`
  display: flex;
  align-items: center;
  height: 42px;

  p {
    color: var(--lightest-slate);
    padding: 10px;
    margin: 0px 5px;
    font-size: var(--fz-xs);
    cursor: pointer;
    transition: var(--transition);
    &:hover {
      color: var(--green);
    }
  }
  p span {
    margin-right: 5px;
    color: var(--green);
    font-size: var(--fz-xxs);
  }
`;

export const ResumeBtn = styled.button`
  &:hover {
    background-color: var(--green-tint);
  }
`;

// mobile nav
const MobileNav = styled.div`
  display: none;

  @media ${device.mdM} {
    display: block;
  }
`;
